{
  "version": 1,
  "asset_id": "351e12ca-f026-4dc2-9e76-95118b661aa7",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/351e12ca-f026-4dc2-9e76-95118b661aa7/appliedlabs-240.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/351e12ca-f026-4dc2-9e76-95118b661aa7/appliedlabs-240.webp",
  "original_filename": "appliedlabs-240.webp",
  "size": 5596,
  "content_type": "image/webp",
  "created_at": "2026-09-18T14:38:40Z"
}
